// import React from 'react';
// import { getImageUrl } from '../../utils/imageUtils';
// import { motion } from 'framer-motion';
// import { Reveal, staggerContainer, revealUp, zoomIn } from '../common/Reveal';
// import { useTheme } from '../../context/ThemeContext';

// const HomeAbout = ({ about, management }) => {
//   const { colors } = useTheme();
//   return (
//     <section style={{ padding: '4rem 2rem', background: colors.backgroundGradient }}>
//       <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
//         <motion.div variants={staggerContainer} initial="hidden" whileInView="show" viewport={{ once: true }} style={{ textAlign: 'center', marginBottom: '3rem' }}>
//           <Reveal as={motion.h2} variants={revealUp} style={{ fontSize: '2.5rem', fontWeight: '700', color: colors.text, marginBottom: '1rem' }}>About <span className="gradient-text">Gurukul Shikshan Samuh</span></Reveal>
//           <Reveal as={motion.p} variants={revealUp} style={{ fontSize: '1.1rem', color: colors.textSecondary, maxWidth: '800px', margin: '0 auto' }}>{about.shortInfo}</Reveal>
//         </motion.div>
//         <motion.div variants={staggerContainer} initial="hidden" whileInView="show" viewport={{ once: true }} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', marginBottom: '4rem' }}>
//           <Reveal as={motion.div} variants={zoomIn} style={{ background: colors.card, padding: '2rem', borderRadius: '1rem', boxShadow: colors.cardShadow, textAlign: 'center' }}>
//             <h3 style={{ fontSize: '1.5rem', fontWeight: '600', color: colors.primary, marginBottom: '1rem' }}>Our Vision</h3>
//             <p style={{ color: colors.textSecondary }}>{about.vision}</p>
//           </Reveal>
//           <Reveal as={motion.div} variants={zoomIn} style={{ background: colors.card, padding: '2rem', borderRadius: '1rem', boxShadow: colors.cardShadow, textAlign: 'center' }}>
//             <h3 style={{ fontSize: '1.5rem', fontWeight: '600', color: colors.primary, marginBottom: '1rem' }}>Our Mission</h3>
//             <p style={{ color: colors.textSecondary }}>{about.mission}</p>
//           </Reveal>
//         </motion.div>
//         <div style={{ textAlign: 'center' }}>
//           <Reveal as={motion.h3} variants={revealUp} style={{ fontSize: '2rem', fontWeight: '600', color: colors.text, marginBottom: '2rem' }}>Leadership</Reveal>
//           <div style={{ display: 'flex', justifyContent: 'center', gap: '3rem', flexWrap: 'wrap' }}>
//             {([...management]
//               .sort((a, b) => {
//                 const rank = (t) => {
//                   const title = (t || '').toLowerCase();
//                   if (title.includes('chairman') && !title.includes('vice')) return 1;
//                   if (title.includes('vice') && title.includes('chairman')) return 2;
//                   return 3;
//                 };
//                 return rank(a.title) - rank(b.title);
//               })
//               .slice(0, 2)  // show up to two leaders
//             ).map((person, index) => {
//               const imageUrl = getImageUrl(person.photo);
//               return (
//                 <Reveal as={motion.div} key={index} variants={zoomIn} style={{ textAlign: 'center', minWidth: '250px' }}>
//                   {imageUrl ? (
//                     <img src={imageUrl} alt={person.name} style={{ width: '120px', height: '120px', borderRadius: '50%', objectFit: 'cover', marginBottom: '1rem', border: `4px solid ${colors.primary}` }} onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }} />
//                   ) : null}
//                   {!imageUrl && (
//                     <div style={{ width: '120px', height: '120px', borderRadius: '50%', background: colors.backgroundGradient, margin: '0 auto 1rem auto', display: 'flex', alignItems: 'center', justifyContent: 'center', border: `4px solid ${colors.primary}`, color: colors.textSecondary, fontSize: '2rem', fontWeight: '600' }}>
//                       {person.name ? person.name.charAt(0).toUpperCase() : '?'}
//                     </div>
//                   )}
//                   <h4 style={{ fontSize: '1.2rem', fontWeight: '600', color: colors.text, marginBottom: '0.5rem' }}>{person.name}</h4>
//                   <p style={{ color: colors.primary, fontWeight: '500' }}>{person.title}</p>
//                 </Reveal>
//               );
//             })}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };
// export default HomeAbout;



import React from 'react';
import { getImageUrl } from '../../utils/imageUtils';
import { motion } from 'framer-motion';
import {
  Reveal,
  staggerContainer,
  revealUp,
  zoomIn
} from '../common/Reveal';
import { useTheme } from '../../context/ThemeContext';

const HomeAbout = ({ about, management }) => {
  const { colors } = useTheme();

  const leaders = [...(management || [])]
    .sort((a, b) => {
      const rank = (title) => {
        const value = (title || '').toLowerCase();

        if (
          value.includes('chairman') &&
          !value.includes('vice')
        ) {
          return 1;
        }

        if (
          value.includes('vice') &&
          value.includes('chairman')
        ) {
          return 2;
        }

        return 3;
      };

      return rank(a.title) - rank(b.title);
    })
    .slice(0, 2);

  return (
    <section
      className="home-about-section"
      style={{
        background: colors.backgroundGradient,
        color: colors.text
      }}
    >
      <style>{`
        .home-about-section {
          width: 100%;
          padding: 64px 24px;
          box-sizing: border-box;
          overflow: hidden;
        }

        .home-about-container {
          width: 100%;
          max-width: 1240px;
          margin: 0 auto;
        }

        .home-about-heading {
          text-align: center;
          margin-bottom: 42px;
        }

        .home-about-title {
          font-size: clamp(1.8rem, 3vw, 2.5rem);
          line-height: 1.3;
          font-weight: 700;
          margin: 0 0 16px;
        }

        .home-about-description {
          max-width: 820px;
          margin: 0 auto;
          font-size: 1.05rem;
          line-height: 1.8;
        }

        .home-about-values {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 24px;
          margin-bottom: 68px;
        }

        .home-about-value-card {
          min-width: 0;
          box-sizing: border-box;
          padding: 32px 28px;
          border-radius: 16px;
          text-align: center;
          box-shadow: ${colors.cardShadow};
          border: 1px solid ${colors.textSecondary}20;
        }

        .home-about-value-title {
          font-size: 1.4rem;
          font-weight: 700;
          margin: 0 0 14px;
        }

        .home-about-value-text {
          font-size: 1rem;
          line-height: 1.8;
          margin: 0;
          overflow-wrap: anywhere;
        }

        .home-about-leadership {
          width: 100%;
          text-align: center;
        }

        .home-about-leadership-heading {
          font-size: clamp(1.8rem, 3vw, 2.25rem);
          font-weight: 700;
          line-height: 1.3;
          margin: 0 0 12px;
        }

        .home-about-leadership-subtitle {
          margin: 0 auto 36px;
          font-size: 1rem;
          line-height: 1.7;
          max-width: 600px;
        }

        .home-about-leaders {
          width: 100%;
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 32px;
          align-items: stretch;
        }

        .home-about-leader-card {
          min-width: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          padding: 32px 22px;
          border-radius: 20px;
          box-sizing: border-box;
          background: ${colors.card};
          border: 1px solid ${colors.textSecondary}20;
          box-shadow: 0 8px 28px rgba(0, 0, 0, 0.06);
          transition:
            transform 0.3s ease,
            box-shadow 0.3s ease;
        }

        .home-about-leader-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 14px 35px rgba(0, 0, 0, 0.10);
        }

        .home-about-leader-image-wrap {
          width: clamp(180px, 22vw, 270px);
          height: clamp(180px, 22vw, 270px);
          flex-shrink: 0;
          border-radius: 50%;
          padding: 4px;
          box-sizing: border-box;
          border: 1px solid ${colors.textSecondary}35;
          background: ${colors.card};
          margin: 0 auto 24px;
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.10);
          overflow: hidden;
        }

        .home-about-leader-image {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover;
          object-position: center top;
        }

        .home-about-leader-fallback {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 4rem;
          font-weight: 700;
          background: ${colors.backgroundGradient};
          color: ${colors.textSecondary};
        }

        .home-about-leader-name {
          font-size: clamp(1.25rem, 2vw, 1.75rem);
          line-height: 1.4;
          font-weight: 700;
          margin: 0 0 12px;
          max-width: 100%;
          overflow-wrap: anywhere;
        }

        .home-about-leader-divider {
          width: 42px;
          height: 2px;
          border-radius: 2px;
          background: ${colors.textSecondary}70;
          margin: 0 auto 14px;
        }

        .home-about-leader-title {
          font-size: clamp(1rem, 1.5vw, 1.2rem);
          line-height: 1.6;
          font-weight: 600;
          margin: 0;
          overflow-wrap: anywhere;
        }

        @media (min-width: 1400px) {
          .home-about-container {
            max-width: 1320px;
          }

          .home-about-leaders {
            gap: 44px;
          }
        }

        @media (max-width: 768px) {
          .home-about-section {
            padding: 44px 18px;
          }

          .home-about-heading {
            margin-bottom: 30px;
          }

          .home-about-title {
            font-size: 1.8rem;
          }

          .home-about-description {
            font-size: 0.95rem;
            line-height: 1.75;
          }

          .home-about-values {
            gap: 16px;
            margin-bottom: 48px;
          }

          .home-about-value-card {
            padding: 24px 18px;
          }

          .home-about-value-title {
            font-size: 1.25rem;
          }

          .home-about-value-text {
            font-size: 0.94rem;
          }

          .home-about-leaders {
            gap: 18px;
          }

          .home-about-leader-card {
            padding: 26px 14px;
            border-radius: 16px;
          }

          .home-about-leader-image-wrap {
            width: clamp(145px, 27vw, 205px);
            height: clamp(145px, 27vw, 205px);
            padding: 4px;
            margin-bottom: 20px;
          }

          .home-about-leader-name {
            font-size: 1.2rem;
          }

          .home-about-leader-title {
            font-size: 0.95rem;
          }

          .home-about-leadership-subtitle {
            margin-bottom: 26px;
          }
        }

        @media (max-width: 480px) {
          .home-about-section {
            padding: 36px 14px;
          }

          .home-about-title {
            font-size: 1.55rem;
          }

          .home-about-description {
            font-size: 0.9rem;
          }

          .home-about-values {
            grid-template-columns: 1fr;
            gap: 14px;
            margin-bottom: 42px;
          }

          .home-about-value-card {
            padding: 23px 18px;
          }

          .home-about-leadership-heading {
            font-size: 1.65rem;
          }

          .home-about-leaders {
            grid-template-columns: 1fr;
            gap: 20px;
            max-width: 360px;
            margin: 0 auto;
          }

          .home-about-leader-card {
            padding: 28px 18px;
          }

          .home-about-leader-image-wrap {
            width: 210px;
            height: 210px;
            margin-bottom: 20px;
          }

          .home-about-leader-name {
            font-size: 1.35rem;
          }

          .home-about-leader-title {
            font-size: 1rem;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .home-about-leader-card {
            transition: none;
          }

          .home-about-leader-card:hover {
            transform: none;
          }
        }
      `}</style>

      <div className="home-about-container">
        {/* About heading */}
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="home-about-heading"
        >
          <Reveal
            as={motion.h2}
            variants={revealUp}
            className="home-about-title"
          >
            About{' '}
            <span className="gradient-text">
              Gurukul Shikshan Samuh
            </span>
          </Reveal>

          <Reveal
            as={motion.p}
            variants={revealUp}
            className="home-about-description"
            style={{ color: colors.textSecondary }}
          >
            {about.shortInfo}
          </Reveal>
        </motion.div>

        {/* Vision and Mission */}
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="home-about-values"
        >
          <Reveal
            as={motion.div}
            variants={zoomIn}
            className="home-about-value-card"
            style={{ background: colors.card }}
          >
            <h3
              className="home-about-value-title"
              style={{ color: colors.primary }}
            >
              Our Vision
            </h3>

            <p
              className="home-about-value-text"
              style={{ color: colors.textSecondary }}
            >
              {about.vision}
            </p>
          </Reveal>

          <Reveal
            as={motion.div}
            variants={zoomIn}
            className="home-about-value-card"
            style={{ background: colors.card }}
          >
            <h3
              className="home-about-value-title"
              style={{ color: colors.primary }}
            >
              Our Mission
            </h3>

            <p
              className="home-about-value-text"
              style={{ color: colors.textSecondary }}
            >
              {about.mission}
            </p>
          </Reveal>
        </motion.div>

        {/* Leadership */}
        <section className="home-about-leadership">
          <Reveal
            as={motion.h3}
            variants={revealUp}
            className="home-about-leadership-heading"
          >
            Leadership
          </Reveal>

          <p
            className="home-about-leadership-subtitle"
            style={{ color: colors.textSecondary }}
          >
            Meet the leaders guiding Gurukul Shikshan Samuh
            towards excellence in education.
          </p>

          <motion.div
            variants={staggerContainer}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            className="home-about-leaders"
          >
            {leaders.map((person, index) => {
              const imageUrl = getImageUrl(person.photo);

              return (
                <Reveal
                  as={motion.div}
                  key={person.id || `${person.name}-${index}`}
                  variants={zoomIn}
                  className="home-about-leader-card"
                >
                  <div className="home-about-leader-image-wrap">
                    {imageUrl ? (
                      <img
                        src={imageUrl}
                        alt={person.name || 'Leadership profile'}
                        className="home-about-leader-image"
                        onError={(event) => {
                          event.currentTarget.style.display = 'none';

                          const fallback =
                            event.currentTarget.nextElementSibling;

                          if (fallback) {
                            fallback.style.display = 'flex';
                          }
                        }}
                      />
                    ) : null}

                    <div
                      className="home-about-leader-fallback"
                      style={{
                        display: imageUrl ? 'none' : 'flex'
                      }}
                    >
                      {person.name
                        ? person.name.charAt(0).toUpperCase()
                        : '?'}
                    </div>
                  </div>

                  <h4
                    className="home-about-leader-name"
                    style={{ color: colors.text }}
                  >
                    {person.name}
                  </h4>

                  <div className="home-about-leader-divider" />

                  <p
                    className="home-about-leader-title"
                    style={{ color: colors.primary }}
                  >
                    {person.title}
                  </p>
                </Reveal>
              );
            })}
          </motion.div>
        </section>
      </div>
    </section>
  );
};

export default HomeAbout;
